var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client, utils, parsers } from '@passwordless-id/webauthn';
import { BigNumber } from 'ethers';
import { arrayify, keccak256 } from 'ethers/lib/utils';
import { WebAuthnUtils } from './utils/WebAuthnUtils';
export class PassKeyKeyPair {
    constructor(keyId, pubKeyX, pubKeyY, webAuthnClient, name, aaguid, manufacturer, regTime) {
        this.keyHash = BigNumber.from(keccak256(new TextEncoder().encode(keyId)));
        this.pubKeyX = pubKeyX;
        this.pubKeyY = pubKeyY;
        this.webAuthnClient = webAuthnClient;
        this.keyId = keyId;
        this.name = name;
        this.aaguid = aaguid;
        this.manufacturer = manufacturer;
        this.regTime = regTime;
    }
    static getValidPassKeyPair(webAuthnClient, passkeyIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const authData = yield webAuthnClient.authenticate(utils.randomChallenge(), passkeyIds, { userVerification: 'required', authenticatorType: 'both' });
            const sig = WebAuthnUtils.getMessageSignature(authData.signature);
            const parsedAuth = parsers.parseAuthentication(authData);
            return new PassKeyKeyPair(parsedAuth.credentialId, BigNumber.from(0), BigNumber.from(0), webAuthnClient, parsedAuth.authenticator.name, parsedAuth.authenticator.aaguid, parsedAuth.authenticator.name, Date.now());
        });
    }
    signChallenge(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            // ophash is a keccak256 hash of the user operation as a hex string
            // this needs to be base64url encoded from raw bytes of the hash
            const challenge = utils.toBase64url(arrayify(payload)).replace(/=/g, '');
            const authData = yield this.webAuthnClient.authenticate(challenge, [this.keyId], { userVerification: 'required', authenticatorType: 'both' });
            const sig = WebAuthnUtils.getMessageSignature(authData.signature);
            const clientDataJSON = new TextDecoder().decode(utils.parseBase64url(authData.clientData));
            const challengePos = clientDataJSON.indexOf(challenge);
            const challengePrefix = clientDataJSON.substring(0, challengePos);
            const challengeSuffix = clientDataJSON.substring(challengePos + challenge.length);
            const authenticatorData = new Uint8Array(utils.parseBase64url(authData.authenticatorData));
            return {
                id: this.keyHash,
                r: sig[0],
                s: sig[1],
                authData: authenticatorData,
                clientDataPrefix: challengePrefix,
                clientDataSuffix: challengeSuffix
            };
        });
    }
}
export class WebAuthnWrapper {
    constructor() {
    }
    register(challenge, name, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return client.register(name ? name : utils.randomChallenge(), challenge, options);
        });
    }
    authenticate(challenge, keyid, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return client.authenticate(keyid ? keyid : [], challenge, options);
        });
    }
    registerPassKey(payload, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const regData = yield this.register(payload, name, { authenticatorType: 'both', userVerification: 'required' });
            const parsedData = parsers.parseRegistration(regData);
            let pkey = yield WebAuthnUtils.getPublicKeyFromBytes(parsedData.credential.publicKey);
            return new PassKeyKeyPair(parsedData.credential.id, pkey[0], pkey[1], this, name, parsedData.authenticator.aaguid, parsedData.authenticator.name, Date.now());
        });
    }
}
